import React, { useState, useEffect } from "react";
import { Input } from "antd";

const AlphabetInput = ({ value, onChange, placeholder, maxLength, ...rest }) => {
    const [inputValue, setInputValue] = useState(value || "");

    // Sync value from parent (e.g., form.setFieldsValue)
    useEffect(() => {
        setInputValue(value || "");
    }, [value]);

    const handleKeyPress = (e) => {
        const char = e.key;
        if (!/^[a-zA-Z]$/.test(char)) {
            e.preventDefault();
        }
    };

    const handleChange = (e) => {
        let val = e.target.value;
        // Remove any non-alphabet characters
        val = val.replace(/[^a-zA-Z]/g, "");
        setInputValue(val);
        if (onChange) {
            onChange(val);
        }
    };

    return (
        <Input
            {...rest}
            value={inputValue}
            onKeyPress={handleKeyPress}
            onChange={handleChange}
            placeholder={placeholder}
            maxLength={maxLength}
        />
    );
};

export default AlphabetInput;
